import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../common/Context";
import ReBox from "../../common/ReBox";
import LoadingWheel from "../../common/LoadingWheel";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SIGNIN_PATH } from "../../../constants";
import { white } from "../../../theme/colours";

const CustomToken = () => {
  const { t } = useTranslation("Account");
  const {
    signError,
    setSignError,
    firebaseState,
    customToken,
    tokenLoading,
    setTokenLoading,
    currentUser,
  } = useContext(GlobalContext);

  const [linkMsg, setLinkMsg] = useState(t("linkingList")[0]);
  const history = useHistory();

  const messageBox = {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    width: { xs: "80%", md: "25%" },
    height: "30%",
    m: "0",
    p: "2rem",
    background: white,
    textAlign: "center",
  };
  const bigText = { mb: "1rem", fontSize: "1.25rem", fontWeight: 900 };

  const container = {
    p: "0.5rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };
  const loadBox = { position: "relative", height: "5rem" };
  if (customToken) {
    window.localStorage.setItem("tokenSignIn", customToken);
  }
  useEffect(() => {
    const signInWithToken = async () => {
      try {
        setTokenLoading(true);
        await firebaseState.signInWithCustomToken(customToken);
      } catch (e) {
        setTokenLoading(false);
        setSignError("Sign in with token failed");
        setSignError(
          "There was an error with signing in... Please proceed to sign in manually",
        );
        setTimeout(() => {}, 3000);
        history.push(SIGNIN_PATH);
      }
    };
    customToken && !currentUser.authUser?.uid
      ? signInWithToken()
      : history.push(SIGNIN_PATH);
  }, [customToken, firebaseState, setTokenLoading, setSignError]);

  useEffect(() => {
    var i = 0;
    const changeMsg = () => {
      setTimeout(() => {
        const msgs = t("linkingList");
        setLinkMsg(msgs[i + 1]);
        if (i < msgs.length - 2) {
          i++;
          changeMsg();
        }
      }, 5000);
    };
    tokenLoading && changeMsg();
  }, [tokenLoading, t]);

  useEffect(() => {
    window.history.replaceState({}, document.title);
  }, []);

  return tokenLoading ? (
    <ReBox style={{ ...messageBox, ...container }}>
      <Box style={loadBox}>
        <LoadingWheel width={4} />
      </Box>
      <Typography sx={bigText} color="primary">
        {t("hangTight")}
      </Typography>
      <Typography color="primary">{linkMsg}..</Typography>
    </ReBox>
  ) : signError ? (
    <ReBox style={{ ...messageBox, ...container }}>
      <Typography color="error" sx={{ fontSize: "20px" }}>
        {signError}
      </Typography>
    </ReBox>
  ) : (
    <></>
  );
};

export default CustomToken;
